export default {
  btc__invoice: 'Invoice',
  btc__time_remaining: 'Time remaining',
  btc__amount: 'Amount',
  btc__amount_to_pay: 'Amount to pay',
  btc__exchange_rate: 'Exchange rate ({from}/{to})',
  btc__network_address: '{currency} ({network}) address to pay',
  btc__copy: 'Copy',
  btc__return_to_site: 'Return to website',
};
